import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseModel } from "./UseModel";

export default function ModelAutoComplete(props) {
  const { getAllModelList } = UseModel();
  const [productModelRes, setProductModelRes] = React.useState();
  const [selectedModel, setSelectedModel] = React.useState();

  useEffect(() => {
    getAllModelList((models) => {
      setProductModelRes(models);
    });
  }, []);

  useEffect(() => {
    if (productModelRes && props.selectedModelID) {
      setSelectedModel(
        productModelRes.models.find((m) => m.id == props.selectedModelID)
      );
    }
  }, [productModelRes, props.selectedModelID]);

  useEffect(() => {
    if (selectedModel) {
      props.setter({
        ...props.lvl3State,
        modelID: selectedModel.id,
      });
    }
  }, [selectedModel]);

  return productModelRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedModel ? selectedModel : ""}
        options={productModelRes.models ? productModelRes.models : []}
        getOptionLabel={(models) => (models.faName ? models.faName : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="مدل" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedModel(newValue);
          } else {
            setSelectedModel();
            props.setter({
              ...props.lvl3State,
              modelID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllModelList((models) => {
            setProductModelRes(models);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/models" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
